/* istanbul ignore file */
import { IDropdownOption } from '@ui-modules/types';

const DEFAULT_MAX_PASSENGER_CAPACITY = 10;

export const paxOptions = [...Array(DEFAULT_MAX_PASSENGER_CAPACITY)].map(
  (_, idx: number): IDropdownOption => ({ label: String(idx + 1), value: String(idx + 1) }),
);
